<template lang="pug">
.v-contacts.contacts(v-if="data" )
	.container
		.contacts__main-section(:style="{backgroundImage: data?.background ? `url(${data.background})` : '#FFFFFF' }")
			.contacts__main-section-cover
			.contacts__main-section-content
				h1.contacts__main-section-title(v-if="data.title" ) {{ data.title }}
				.contacts__main-section-subtitle(v-if="data.subtitle" ) {{ data.subtitle }}
				.contacts__main-section-block
					.main-section-block
						.main-section-block__form
							v-form(:data-source="data.form" @success="onSuccess" :bxajaxid="data.bxajaxid")
							.main-section-block__success(v-if="success" )
								v-svg-icon.main-section-block__success-icon(:icon="success.icon")
						.main-section-block__contacts
							h2.main-section-block__contacts-title(v-if="data.contacts.title" ) {{ data.contacts.title }}
							template(v-if="data.contacts.items" )
								.main-section-block__contacts-info(v-for="(item, index) in data.contacts.items" :key="index")
									.contacts-info__title(v-if="item.title" ) {{ item.title }}
									component.contacts-info__mail(v-if="item.link" :is="item.link.href ? 'a' : 'span'" :href="item.link.href" v-html="item.link?.text")

		.contacts__empty-section
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [sourceMixin],

	data() {
		return {
			data: null,
			success: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		onSuccess(message) {
			if(!this.success) {
				this.success = message;
				setTimeout(() => {
					this.success = null;
				}, 2000)
			}
		}
	}
};
</script>